angular.module('TurneroApp').component('coBloqueoAlta', {
    bindings: {
        centroAtencionSeleccionado: '<',
        ctrlPadre: '='
    },
    controller: [
        'bloqueoCalendarioService',
        'utilsService',
        'TurneroAppConstant',
        function (bloqueoCalendarioService, utilsService, TurneroAppConstant) {
            var ctrl = this;

            ctrl.permisos = TurneroAppConstant.Permisos;
            ctrl.bloqueoAlta = {};
            ctrl.Fecha_Desde_Min = ctrl.Fecha_Desde_Max = ctrl.Fecha_Hasta_Min = ctrl.Fecha_Hasta_Max = new Date();
            ctrl.Horas_Bloqueos = null;
            ctrl.infoAlta = null;

            ctrl.errores = {
                Motivo: false,
                Id_Agenda: false,
                Fecha_Desde: false,
                Fecha_Hasta: false,
                Hora_Desde: false,
                Hora_Hasta: false,
            };

            ctrl.$onInit = function () {
                ctrl.ctrlPadre.tLoadAlta = function () {
                    ctrl.bloqueoAlta = {};

                    ctrl.errores = {
                        Motivo: false,
                        Id_Agenda: false,
                        Fecha_Desde: false,
                        Fecha_Hasta: false,
                        Hora_Desde: false,
                        Hora_Hasta: false,
                    };

                    utilsService.swalTitle('Cargando información', 'info')
                    bloqueoCalendarioService.Get_Bloqueo_Calendario({ 'id_centro_atencion': ctrl.centroAtencionSeleccionado.id }).$promise.then(function (resultado) {
                        ctrl.infoAlta = resultado.Data
                        ctrl.Horas_Bloqueos = null
                        swal.close();
                    }).catch(function (error) {
                        utilsService.errores(error);
                    });
                }
            }
            
            ctrl.obtenerFechasBloqueos = function (Id_Agenda) {

                bloqueoCalendarioService.Get_Fecha_Hora({ 'id_agenda': Id_Agenda }).$promise.then(function (resultado) {
                    ctrl.Fechas_Bloqueos = resultado.Data.Fechas_Disponibles;

                    if (ctrl.Fechas_Bloqueos != null)
                    {
                        ctrl.Fecha_Desde_Max = ctrl.Fecha_Hasta_Max = new Date(ctrl.Fechas_Bloqueos[ctrl.Fechas_Bloqueos.length - 1].text);
                    }

                    ctrl.Horas_Bloqueos = resultado.Data.Horas_Disponibles;
                }).catch(function (error) {
                    utilsService.errores(error);
                });
            }

            ctrl.cambiarFechaDesde = function (fecha) {
                ctrl.Fecha_Hasta_Min = fecha !== undefined ? fecha : ctrl.Fecha_Desde_Min;
            }

            ctrl.cambiarFechaHasta = function (fecha) {
                ctrl.Fecha_Desde_Max = fecha !== undefined ? fecha : ctrl.Fecha_Hasta_Max;
            }

            ctrl.crear_Bloqueo = function (bloqueo) {
                bloqueo.Fecha_Desde = bloqueo.Fecha_Desde ? bloqueo.Fecha_Desde : new Date();
                bloqueo.Fecha_Hasta = bloqueo.Fecha_Hasta ? bloqueo.Fecha_Hasta : new Date();

                ctrl.errores = {
                    Id_Agenda: !(bloqueo.Id_Agenda),
                    Motivo: !(bloqueo.Id_Motivo),
                    Fecha_Desde: !(bloqueo.Fecha_Desde),
                    Fecha_Hasta: !(bloqueo.Fecha_Hasta),
                    Fecha_Hasta_Mayor_Desde: (bloqueo.Fecha_Desde && bloqueo.Fecha_Hasta ? bloqueo.Fecha_Hasta < bloqueo.Fecha_Desde : true),
                    Hora_Desde: !(bloqueo.Hora_Desde),
                    Hora_Hasta: !(bloqueo.Hora_Hasta),
                }

                if (ctrl.errores.Id_Agenda || ctrl.errores.Motivo || ctrl.errores.Fecha_Desde || ctrl.errores.Fecha_Hasta || ctrl.errores.Hora_Desde || ctrl.errores.Hora_Hasta || ctrl.errores.Fecha_Hasta_Mayor_Desde) {
                    return
                }

                var opciones = [];
                var combo = '';
                if (ctrl.infoAlta.Estados.length > 0) {
                    for (var i = 0; i < ctrl.infoAlta.Estados.length; i++) {
                        var Indice = 0;
                        var valor = '';
                        var array = [];
                        angular.forEach(ctrl.infoAlta.Estados[i], function (value, key) {
                            if (key == 'id') {
                                Indice = value;
                            }
                            if (key == 'text') {
                                valor = value;
                            }
                        });
                        opciones[Indice] = valor;
                    }
                }

                //Enviamos en formato simil JSON/ISO8601 para que sea parseado en el backend con cualquier configuración regional y con la hora Desde/Hasta local al server
                bloqueoCalendarioService.Turnos_Afectados({ //'value': bloqueo
                    'value.Fecha_Desde': moment(bloqueo.Fecha_Desde).format('YYYY-MM-DDT00:00:00'),
                    'value.Fecha_Hasta': moment(bloqueo.Fecha_Hasta).format('YYYY-MM-DDT00:00:00'),
                    'value.Hora_Desde': bloqueo.Hora_Desde,
                    'value.Hora_Hasta': bloqueo.Hora_Hasta,
                    'value.Id_Agenda': bloqueo.Id_Agenda,
                }).$promise.then(function (result) {
                    if ((result.Data && result.Data > 0)) {//si el procedimiento devuelve datos
                        swal({
                            title: 'Bloquear Atención',
                            html: "Existen " + result.Data + " turno/s afectados al bloqueo.<br/>¿Confirma que desea bloquear la atención? <br/> Si es así, seleccione el estado al cual se deben pasar los turnos que se encuentran comprendidos en el rango del bloqueo: <br/> ",
                            type: 'warning',
                            input: 'select',
                            showCancelButton: true,
                            inputOptions: opciones,
                            confirmButtonColor: '#004b81',
                            cancelButtonColor: '#971b2f',
                            confirmButtonText: 'Aceptar'
                        }).then(function (input) {

                            bloqueo.Id_Estado = input;
                            ctrl.darAltaBloqueo(bloqueo)
                        });
                    }
                    else if (result.Data == 0) {
                        bloqueo.Id_Estado = null;
                        ctrl.darAltaBloqueo(bloqueo)

                    }
                }).catch(function (error) {
                    utilsService.errores(error);
                });
            }

            ctrl.darAltaBloqueo = function (bloqueo) {
                utilsService.swalTitle('Generando bloqueo de atención', 'info')
                bloqueoCalendarioService.Post_Bloqueo_Calendario(bloqueo).$promise.then(function (resultado) {
                    swal.close();
                    if (resultado.Data && resultado.Data != 'null') {
                        swal({
                            title: 'Información',
                            html: resultado.Data,
                            type: 'info',
                            showCancelButton: false,
                            confirmButtonColor: '#004b81',
                            confirmButtonText: 'Aceptar'
                        }).then(function () {
                            ctrl.ctrlPadre.getConsultaInfo();
                        })
                    } else {
                        swal({
                            title: 'Alta de Bloqueo',
                            html: 'El bloqueo de atención se registró correctamente',
                            type: 'success',
                            showCancelButton: false,
                            confirmButtonColor: '#004b81',
                            confirmButtonText: 'Aceptar'
                        }).then(function () {
                            ctrl.ctrlPadre.getConsultaInfo();
                        })
                    }
                }).catch(function (error) {
                    utilsService.errores(error);
                });

            }

            ctrl.cancelar = function () {
                ctrl.ctrlPadre.getConsultaInfo();
            }
        }
    ],
    template: require('./altaBloqueo.html')
});


// WEBPACK FOOTER //
// ./app/components/supervision/Bloqueo_Atencion/altaBloqueoComponent.js